(() => {
  if (!document.documentElement.classList.contains('wearse-easysell-disabled')) return;

  let cleanupQueued = false;

  function cleanup() {
    cleanupQueued = false;

    if (window.EASYSELL_CONFIG && typeof window.EASYSELL_CONFIG === 'object') {
      window.EASYSELL_CONFIG.active = false;
    }

    document.querySelectorAll('style#es-css').forEach((style) => style.remove());
    document.querySelectorAll('#easysell').forEach((form) => form.remove());

    document
      .querySelectorAll(
        "button[name='add'], form[action$='/cart/add'] button[type='submit'], button[data-wearse-command-now]",
      )
      .forEach((button) => {
        button.hidden = false;
        button.style.removeProperty('display');
        button.style.removeProperty('visibility');
        button.style.removeProperty('opacity');
        button.style.removeProperty('pointer-events');
      });
  }

  function queueCleanup() {
    if (cleanupQueued) return;
    cleanupQueued = true;
    queueMicrotask(cleanup);
  }

  const observer = new MutationObserver(queueCleanup);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  cleanup();
  document.addEventListener('DOMContentLoaded', cleanup, { once: true });
  [50, 250, 1000, 3000].forEach((delay) => setTimeout(cleanup, delay));
})();
